import { render } from "./PosTicket.vue?vue&type=template&id=d4c9f686&scoped=true"
import script from "./PosTicket.vue?vue&type=script&lang=js"
export * from "./PosTicket.vue?vue&type=script&lang=js"

import "./PosTicket.vue?vue&type=style&index=0&id=d4c9f686&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/TEAMENSUENO/mi-stock-teamensueno-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4c9f686"]])

export default __exports__